import { render, staticRenderFns } from "./ChartTemp3.vue?vue&type=template&id=5674a345&scoped=true&"
import script from "./ChartTemp3.vue?vue&type=script&lang=js&"
export * from "./ChartTemp3.vue?vue&type=script&lang=js&"
import style0 from "./ChartTemp3.vue?vue&type=style&index=0&id=5674a345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674a345",
  null
  
)

export default component.exports